var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiles1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_41_1",
    "data-name": "Component 41 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3327",
    "data-name": "Rectangle 3327",
    width: 100,
    height: 100,
    transform: "translate(929 318)",
    fill: "#2e71fc",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3328",
    "data-name": "Rectangle 3328",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(899 320)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_188",
    "data-name": "Mask Group 188",
    transform: "translate(-919 -308)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(939.714 318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M91.965,48.571H60.714A10.714,10.714,0,0,1,50,37.857V6.606a.892.892,0,0,0-.892-.892H28.571A14.286,14.286,0,0,0,14.286,20V91.429a14.286,14.286,0,0,0,14.286,14.286h50A14.286,14.286,0,0,0,92.857,91.429V49.463A.892.892,0,0,0,91.965,48.571ZM71.429,84.286H35.714a3.571,3.571,0,0,1,0-7.143H71.429a3.571,3.571,0,0,1,0,7.143Zm0-17.857H35.714a3.571,3.571,0,0,1,0-7.143H71.429a3.571,3.571,0,0,1,0,7.143Z",
    transform: "translate(-14.286 -5.714)",
    fill: "#2e71fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M81.432,40.122l-32.1-32.1a.448.448,0,0,0-.762.314V37.312a3.571,3.571,0,0,0,3.571,3.571H81.117a.448.448,0,0,0,.314-.762Z",
    transform: "translate(-5.714 -5.169)",
    fill: "#2e71fc",
    opacity: 0.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8774",
    "data-name": "Group 8774",
    transform: "translate(-895 -316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3225",
    "data-name": "Rectangle 3225",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(895 316)",
    fill: "#35ce77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_189",
    "data-name": "Mask Group 189",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("path", {
    id: "checkmark-round",
    d: "M17.083,3.975a1.333,1.333,0,0,0-1.936.326L8.709,13.72,5.163,9.88a1.326,1.326,0,0,0-1.957-.065,1.533,1.533,0,0,0-.061,2.079s4.309,4.781,4.928,5.261a1.333,1.333,0,0,0,1.936-.326l7.382-10.8a1.532,1.532,0,0,0-.308-2.058Z",
    transform: "translate(900.789 321.435)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles1);
export default __webpack_public_path__ + "static/media/files_1.645bbe91379ff72fd39ac0708a40f36c.svg";
export { ForwardRef as ReactComponent };